import type { BadgeProps } from "@/components/ui/Badge";

export function capabilityStatusTone(status: string): BadgeProps["tone"] {
  if (status === "Available") return "mint";
  if (status === "Pilot") return "neutral";
  return "amber";
}
